import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import { getLastSalesRates } from "../../../services/SalesApiServices";

// Earlier sales of the line's item to the invoice's customer, shown in the
// line "Note" panel (the desktop sales form's last-rate grid).
const SalesLastRates = ({ branch, customerId, productId, excludeId, decimals }) => {
  const [rows, setRows] = useState([]);
  const [state, setState] = useState("idle");

  useEffect(() => {
    if (!customerId || !productId || !branch?.guid) {
      setRows([]);
      setState("idle");
      return undefined;
    }
    let live = true;
    setState("loading");
    getLastSalesRates(branch, customerId, productId, excludeId)
      .then((data) => {
        if (!live) return;
        setRows(Array.isArray(data) ? data : []);
        setState("done");
      })
      .catch(() => {
        if (!live) return;
        setRows([]);
        setState("error");
      });
    return () => {
      live = false;
    };
  }, [branch?.guid, customerId, productId, excludeId]);

  const fmt = (v) => (Number(v) || 0).toFixed(decimals);

  let body;
  if (!customerId) body = <div className="si-last__msg">Pick a customer to see earlier sales of this item.</div>;
  else if (state === "loading") body = <div className="si-last__msg">Loading earlier sales…</div>;
  else if (state === "error") body = <div className="si-last__msg">Could not load earlier sales.</div>;
  else if (!rows.length) body = <div className="si-last__msg">No earlier sales of this item to this customer.</div>;
  else
    body = (
      <table className="si-last__table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Invoice</th>
            <th>Unit</th>
            <th className="num">Qty</th>
            <th className="num">Rate</th>
            <th className="num">Disc</th>
            <th className="num">Amount</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={`${r.masterID}-${r.unitID}-${r.price}-${r.quantity}`}>
              <td>{r.invDate ? dayjs(r.invDate).format("DD-MM-YYYY") : ""}</td>
              <td>{r.entryNumber}</td>
              <td>{r.unitName}</td>
              <td className="num">{Number(r.quantity) || 0}</td>
              <td className="num">{fmt(r.price)}</td>
              <td className="num">{fmt(r.discAmt)}</td>
              <td className="num">{fmt(r.netAmt)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );

  return (
    <div className="si-last">
      <div className="si-last__title">Previous sales to this customer</div>
      {body}
    </div>
  );
};

SalesLastRates.propTypes = {
  branch: PropTypes.object,
  customerId: PropTypes.string,
  productId: PropTypes.string,
  excludeId: PropTypes.string,
  decimals: PropTypes.number,
};

SalesLastRates.defaultProps = {
  decimals: 2,
};

export default SalesLastRates;
